import root from 'window-or-global';

export const getURLParamValue = (param: string, location = root.location) => {
  if (!location) return '';

  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(param) || '';
};
